/**
 * Enterprise Subscription Service
 * Cross-platform domain service for SaaS subscriptions, tiers, and service gates.
 */
import { subscriptionApi } from '../../../services/subscriptionApi';

export const subscriptionService = {
  ...subscriptionApi,
};

export default subscriptionService;
